export const IconIdCardFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconIdCardFilled_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconIdCardFilled_svg__a)">
        <path d="M18 13q.424 0 .712-.287A.97.97 0 0 0 19 12a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 11h-3a.97.97 0 0 0-.713.287A.97.97 0 0 0 14 12q0 .424.287.713.288.287.713.287zm0-3q.424 0 .712-.287A.97.97 0 0 0 19 9a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 8h-3a.97.97 0 0 0-.713.287A.97.97 0 0 0 14 9q0 .424.287.713.288.287.713.287zm-9 3q-.9 0-1.625.162-.724.163-1.275.513-.525.325-.8.737a1.57 1.57 0 0 0-.275.888q0 .3.225.5t.55.2h6.4q.325 0 .55-.213a.7.7 0 0 0 .225-.537q0-.424-.275-.825t-.8-.75a4 4 0 0 0-1.275-.513A7.5 7.5 0 0 0 9 13m0-1q.825 0 1.412-.588Q11 10.826 11 10t-.588-1.412A1.93 1.93 0 0 0 9 8q-.825 0-1.412.588A1.93 1.93 0 0 0 7 10q0 .825.588 1.412Q8.175 12 9 12m-5 8q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20z" />
      </g>
    </svg>
  );
};
